import {Routes} from '@angular/router';
import { AuthGuard } from '@core/services/auth-guard.service';
import { CurrentProjectGuard } from '../../projects/services/current-project-guard';
import {EntityChartContentComponent} from './components/entity-chart-content/entity-chart-content.component';
import {EntityChartImportComponent} from './components/entity-chart-import/entity-chart-import.component';
import {EntityChartToolbarComponent} from './components/entity-chart-toolbar/entity-chart-toolbar.component';
import {EntityChartImportToolbarComponent} from './components/entity-chart-import/entity-chart-import-toolbar/entity-chart-import-toolbar.component';


export const entityChartRoutes: Routes = [
  {
    path      : 'cr/footprint/entity-chart',
    component: EntityChartContentComponent,
    canActivate: [AuthGuard, CurrentProjectGuard]
  },
  {
    path      : 'footprint/entity-chart',
    component: EntityChartContentComponent,
    canActivate: [AuthGuard, CurrentProjectGuard]
  },
  {
    path     : 'cr/footprint/entity-chart/entity-chart-import',
    component: EntityChartImportComponent,
    canActivate: [AuthGuard, CurrentProjectGuard]
  },
  {
    path     : 'entity-chart-toolbar',
    component: EntityChartToolbarComponent,
    outlet   : 'top-toolbar',
    canActivate: [AuthGuard, CurrentProjectGuard]
  },
  {
    path     : 'entity-chart-import-toolbar',
    component: EntityChartImportToolbarComponent,
    outlet   : 'top-toolbar',
    canActivate: [AuthGuard, CurrentProjectGuard]
  }
];
